import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ResponderLayout from '../../components/layout/ResponderLayout';
import DashboardHome from './DashboardHome';
import SurveyDetails from './SurveyDetails';
import TakeSurveyEnhanced from './TakeSurveyEnhanced';
import SurveyHistory from './SurveyHistory';
import Profile from './Profile';
import Balance from './Balance';
import Rewards from './Rewards';
import Notifications from './Notifications';
import Referrals from './Referrals';
import SupportChat from './SupportChat';
import SurveyDisqualified from './SurveyDisqualified';

export default function Dashboard() {
  return (
    <ResponderLayout>
      <Routes>
        <Route path="/dashboard" element={<DashboardHome />} />
        <Route path="/surveys/:id" element={<SurveyDetails />} />
        <Route path="/surveys/:id/take" element={<TakeSurveyEnhanced />} />
        <Route path="/surveys/:id/disqualified" element={<SurveyDisqualified />} />
        <Route path="/history" element={<SurveyHistory />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/balance" element={<Balance />} />
        <Route path="/rewards" element={<Rewards />} />
        <Route path="/notifications" element={<Notifications />} />
        <Route path="/referrals" element={<Referrals />} />
        <Route path="/support" element={<SupportChat />} />
      </Routes>
    </ResponderLayout>
  );
}